import { PitchPerformanceHelper } from 'classes/helpers/pitch-performance.helper';
import { IPlotHoverKeys } from 'interfaces/i-pitch-performance';
import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

interface IPlotHoverContext {
  hoveredItemKey: string | undefined;
  setHoveredItemKey: Dispatch<SetStateAction<string | undefined>>;
}

const PlotHoverContext = createContext<IPlotHoverContext>({
  hoveredItemKey: undefined,
  setHoveredItemKey: () => undefined,
});

export const PlotHoverProvider = ({ children }: { children: ReactNode }) => {
  const [hoveredItemKey, setHoveredItemKey] = useState<string>();
  const value = useMemo(
    () => ({ hoveredItemKey, setHoveredItemKey }),
    [hoveredItemKey]
  );

  return (
    <PlotHoverContext.Provider value={value}>
      {children}
    </PlotHoverContext.Provider>
  );
};

export const usePlotHover = () => {
  const { hoveredItemKey, setHoveredItemKey } = useContext(PlotHoverContext);

  const pointOpacity = (keys: IPlotHoverKeys | undefined, baseOpacity = 1) =>
    PitchPerformanceHelper.hoverOpacity(hoveredItemKey, keys, baseOpacity);

  const hoverHandlers = (itemKey: string | undefined) =>
    itemKey
      ? {
          onMouseEnter: () => setHoveredItemKey(itemKey),
          onMouseLeave: () =>
            setHoveredItemKey((current) =>
              current === itemKey ? undefined : current
            ),
        }
      : {};

  return { hoveredItemKey, pointOpacity, hoverHandlers };
};
